import axios from 'axios';
import { GET_NEW_IMAGE_URL, GET_LOADING_IMAGE } from './constants';

/**
 * Get filename to be uploaded.
 * @param filename
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getImage(queryparams) {
  return axios
    .get(GET_NEW_IMAGE_URL, { params: queryparams, withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}

export function getLoadingImage() {
  return axios
    .get(GET_LOADING_IMAGE, { withCredentials: true })
    .catch((error) => {
      return Promise.reject(new Error(error.message));
    });
}
